import { render, staticRenderFns } from "./curd.vue?vue&type=template&id=90b5e2fa&scoped=true&"
import script from "./curd.vue?vue&type=script&lang=js&"
export * from "./curd.vue?vue&type=script&lang=js&"
import style0 from "./curd.vue?vue&type=style&index=0&id=90b5e2fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b5e2fa",
  null
  
)

export default component.exports